<script>
  import { mapState, mapActions } from 'vuex'
  import { TopBar, LoadingOverlay } from '@/components/_shared'
  import { ScreenGroupsContainer } from '@/components/screens'

  export default {
    name: 'screen-groups-view',

    components: {
      TopBar,
      LoadingOverlay,
      ScreenGroupsContainer
    },

    metaInfo: {
      title: 'Screen Groups'
    },

    computed: {
      ...mapState('screenGroups', {
        groups: state => state.groups,
        loading: state => state.loading
      })
    },

    methods: {
      ...mapActions('screenGroups', [
        'loadGroups',
        'clearGroups'
      ]),

      ...mapActions('app', [
        'showModal'
      ])
    },

    created () {
      this.loadGroups()
    },

    destroyed () {
      this.clearGroups()
    }
  }
</script>

<template>
  <div>
    <top-bar title="Screen Groups" icon="desktop">
      <template slot="actions">
        <b-button variant="primary" @click="showModal('ScreenGroupNewModal')">New Group</b-button>
      </template>
    </top-bar>
    <b-container fluid>
      <loading-overlay :is-loading="loading">
        <screen-groups-container :groups="groups"/>
      </loading-overlay>
    </b-container>
  </div>
</template>
